import UserRepository from "./user.repository";
import DevFormRepository from "./dev-form.repository";
import ClassroomRepository from "./classroom.repository";
import StudentRepository from "./student.repository";
import DashboardRepository from "./dashboard.repository";
import TermRepository from "./terms.repository";
import BodyMassRepository from "./bodymass.repository";
import DentalRepository from "./dental.repository";
import SightHearingRepository from "./sighthearing.repository";
import SchoolYearRepository from "./schoolYear.repository";
import RollCallRepository from "./rollcall.repository";
import ReportRepository from "./report.repository";
import HolidayRepository from "./holiday.repository";
import SchoolRepository from "./school.repository";
import CommentRepository from "./comment.repository";
import GradeRepository from "./grade.repository";
import PackageRepository from "./package.repository";

const repositories = {
  users: UserRepository,
  devForms: DevFormRepository,
  classrooms: ClassroomRepository,
  students: StudentRepository,
  terms: TermRepository,
  dashboard: DashboardRepository,
  bodymass: BodyMassRepository,
  dental: DentalRepository,
  sighthearing: SightHearingRepository,
  rollcalls: RollCallRepository,
  schoolYear: SchoolYearRepository,
  reports: ReportRepository,
  holidays: HolidayRepository,
  schools: SchoolRepository,
  comments: CommentRepository,
  grades: GradeRepository,
  packages: PackageRepository
};

const RepositoryFactory = {
  get: name => repositories[name]
};

export default RepositoryFactory;
